import { render, staticRenderFns } from "./vFooter.vue?vue&type=template&id=49e2f970&scoped=true"
import script from "./vFooter.vue?vue&type=script&lang=ts"
export * from "./vFooter.vue?vue&type=script&lang=ts"
import style0 from "./vFooter.vue?vue&type=style&index=0&id=49e2f970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2f970",
  null
  
)

export default component.exports